declare global {
  interface Window {
    __CONFIG__?: Record<string, string>;
  }
}

function get(key: string): string | undefined {
  return window.__CONFIG__?.[key] || import.meta.env[key] || undefined;
}

export const config = {
  auth0Domain: get('VITE_AUTH0_DOMAIN') ?? '',
  auth0ClientId: get('VITE_AUTH0_CLIENT_ID') ?? '',
  auth0Audience: get('VITE_AUTH0_AUDIENCE'),
  auth0Organization: get('VITE_AUTH0_ORGANIZATION'),
  apiBaseUrl: get('VITE_API_BASE_URL') ?? '',
};
